import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'

import { StoreData } from '../reducers/typings'
import { IMarketingProduct, IMarketingProductState } from './typings'
import { getLicenseInfo } from './api'
import { LicenseIds } from '@user/components/Settings/Users/constants'

export const licenseAdapter = createEntityAdapter<IMarketingProduct>()

export const initialState =
  licenseAdapter.getInitialState<IMarketingProductState>({
    licenseInformation: null,
  })

export const licenseSlice = createSlice({
  name: 'license',
  initialState,
  reducers: {
    setLicenseInformation: (
      state,
      { payload }: PayloadAction<IMarketingProduct>,
    ) => {
      state.licenseInformation = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLicenseInfo.fulfilled, (state, { payload }) => {
      const licenseData = payload.find((x) => x.id == LicenseIds.LM)
      if (licenseData) {
        state.licenseInformation = licenseData
      }
    })
  },
})

export default licenseSlice.reducer

export const selectLicenseInformation = (state: StoreData) => {
  return state.license.licenseInformation
}

export const { setLicenseInformation } = licenseSlice.actions
